import { Appendix } from "../../../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../../../shared/entities/scripts/study";
import { FormatDate, GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { RenderDateMDY } from "../../../../../../shared/scripts/table-functions";
import { SiteInfo } from "../../../../sites/shared/sites.entities";
import { OutcomeEvent } from "./outcomes.entities";
import { OutcomesLookup } from "./outcomes.lookup";

export class OutcomesDialog {
    static table: any = undefined;

    static Initialize() {
        OutcomesDialog.table = $('#outcomes-details-modal #dialog-details-table').DataTable({
            autoWidth: true,
            info: false,
            paging: false,
            scrollX: true,
            scrollY: '70vh',
            searching: false,
            columns: [
                { data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: "Outcome", title: "Outcome", className: "text-left font-size12 nowrap" },
                { data: "OutcomeStatus", title: "Status", className: "text-left font-size12 nowrap" },
                { data: "Subject", title: "Participant", className: "text-left font-size12 nowrap" },
                { data: "Reason", title: "Reason Not Available", className: "text-left font-size12 nowrap" },
            ],
            buttons: [
                {
                    extend: 'csv',
                    className: "btn btn-secondary",
                    text: '<i class="fas fa-file-download"></i>',
                    charset: 'utf-8',
                    title: "RECOVER-CT Outcomes Details Export",
                }
            ],
        });

        document.getElementById("export-outcomes-btn-dialog")?.addEventListener("click", () => {
            OutcomesDialog.table.button('.buttons-csv').trigger();
        });
    }

    public static ShowDialog(outcomes: OutcomeEvent[]): void {
        //console.log("show", outcomes);
        let showReasonsColumn: boolean = false;
        let tableRows: OutcomeDialogRow[] = outcomes.map((v: OutcomeEvent) => {
            if (!showReasonsColumn && v.OutcomeStatusId == 4) { showReasonsColumn = true; } //only when Not Available
            return new OutcomeDialogRow(v)
        });

        if (OutcomesDialog.table == undefined) { OutcomesDialog.Initialize(); }

        OutcomesDialog.table.column(6).visible(showReasonsColumn);

        OutcomesDialog.table.clear();
        OutcomesDialog.table.rows.add(tableRows).draw();

        $('#outcomes-details-modal').on('shown.bs.modal', () => {
            OutcomesDialog.table.columns.adjust();
            $('#outcomes-details-modal .dataTables_scrollBody').scrollTop(0);
            $('#outcomes-details-modal #modal-title').text("Number of Outcome Events = " + FormatNumberWithCommas(outcomes.length + ""));
            //$('#visits-details-modal-count').text(visits.length);
        });

        $('#outcomes-details-modal').modal('show');

    }
}


export class OutcomeDialogRow {
    Study: string;
    Appendix: string;
    SiteNumber: string;
    Subject: string;
    Outcome: string;
    //OutcomeOrdering: number;
    OutcomeStatus: string;
    Reason: string;

    constructor(event: OutcomeEvent) {
        this.Study = Study.GetStudyName(event.StudyId);
        this.Appendix = Appendix.GetAppendixName(event.AppendixId);
        this.SiteNumber = SiteInfo.FormatSiteNumber(event.SiteNumber);
        this.Subject = event.SubjectId;
        this.Outcome = OutcomesLookup.GetOutcome(event.OutcomeId);
        //this.VisitOrdering = VisitLookup.GetVisitOrdering(event.VisitId);
        this.OutcomeStatus = OutcomesLookup.GetOutcomeStatus(event.OutcomeStatusId);
        this.Reason = OutcomesLookup.GetReasonMissing(event.ReasonId);
    }
}